import { Component, Input, OnInit, OnChanges, SimpleChanges, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

import * as Objects from '@core/objects';

import { AmsFilesListItemMenuClick } from '@core/components/files/lists/files-list-item-menu-click';
import { ThreeDotsMenuItem } from '@core/components/helpers/navigation/three-dots-menu/three-dots-menu-item';
import { UrlService } from '@core/services/url/url.service';
import { AnnotationsService } from '@core/services/annotations/annotations.service';
import { CurrentSessionService } from '@core/services/current-session/current-session.service';


@Component({
    selector: 'core-message-files',
    templateUrl: './message-files.component.html',
    styleUrls: ['./message-files.component.scss']
})
export class MessageFilesComponent implements OnInit, OnChanges{

    @Input() message: Objects.Message;
    @Input() canCreateNotes: boolean = true;
    @Input() notesActionText: string;
    @Input() notesActionStyle: string;
    @Input() prefixUrl: string = '';
    @Input() context: string;

    /**
     * Emitted when file signatures need to be refreshed
     * (e.g., when signature expires and API returns 403)
     */
    @Output() refreshSignaturesNeeded = new EventEmitter<void>();

    public selectedFile: Objects.AmsFile = null;
    public show: boolean = false;
    public notesCounter:  Array<Objects.AnnotationsCounter>;
    public user: Objects.User = null;
    
    private counterUrlPrefix: string;
    public loadingCounter: boolean = false;

    public menu: Array<ThreeDotsMenuItem> = [
        {
            title: "Download File",
            key: "download",
            icon: "download"
        },
        // {
        //     title: "See Notes",
        //     key: "notes",
        //     icon: "notes"
        // },
        // {
        //     title: "Remove",
        //     key: "remove",
        //     icon: "remove"
        // },
    ];
    constructor(private urlSrv: UrlService,
        private cdr: ChangeDetectorRef,
        private annotationsSrv: AnnotationsService,
        private currentSessionSrv: CurrentSessionService ){}

    ngOnInit(){
        this.user = this.currentSessionSrv.getUser();
        this.loadNotes();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if(changes.prefixUrl){
            this.loadNotes();
        }
    }

    notesSaved(notes: Array<Objects.Note>){
        // TODO: review if reload notes heeerrrre or not
        this.loadNotes();
    }

    openNotes(file: Objects.AmsFile){
        if(this.selectedFile != null && this.selectedFile.id == file.id)
            this.selectedFile = null;
        else
            this.selectedFile = file;
    }

    toggleAttachments(){
        this.show = !this.show;
    }

    onMenuClick(menu: AmsFilesListItemMenuClick) {
        switch(menu.key) {
            // case "remove":
            //     this.onClickDeactivate(menu.file);
            //     break;
            // case "notes":
            //     this.openNotes(menu.file);
            //     break;
            case "download":
                window.location.href = this.urlSrv.build('/files/'+menu.file.id);
                break;
        }
    }

    onActionDownloadClick(file: Objects.File){
        window.location.href = this.urlSrv.build('/files/'+file.id);
    }

    // manage the ulr prefix here when message is known
    // june 2026 dual files and attachments in message object, we need to check both for notes and files list
    protected loadNotes() { 
        if(this.message != null && (this.message.attachments ?? this.message.files).length > 0){
            this.counterUrlPrefix = '/messages/'+this.message.id;
            
            // if(this.canCreateNotes) {   
            //     this.menu[1].title = this.notesActionText;
            // }
            // get the notes counter
            if(!this.loadingCounter){
                this.loadingCounter = true; // prevent multiple reloads when onchanges
                this.annotationsSrv.getCounter(this.counterUrlPrefix).subscribe({
                    next: (counter: Objects.AnnotationsCounter[]) => {
                        this.notesCounter = [...counter];
                        this.cdr.detectChanges(); // Force change detection
                        this.loadingCounter = false;
                    },
                    error: (error: HttpErrorResponse) => {
                        console.debug(" ERROR getting message notes counter:",error);
                        this.notesCounter = [];
                        this.loadingCounter = false;
                    }
                })
            }
        } else {
            this.notesCounter = [];
        }
    }

    onRefreshSignaturesNeeded() {
        // File signatures need to be refreshed - emit signal to parent component
        // Parent (MessageComponent) will handle reloading the files from API
        this.refreshSignaturesNeeded.emit();
    }

}
